
import { useState, useRef } from "react";
import { Permission } from "../types";

/**
 * Hook to manage permission state and tracking for the role permissions system
 */
export const usePermissionState = () => {
  const [permissions, setPermissions] = useState<Permission[]>([]);
  const [initialPermissions, setInitialPermissions] = useState<Permission[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isDirty, setIsDirty] = useState<boolean>(false);
  const [loadAttempts, setLoadAttempts] = useState<number>(0);
  const [lastSaveTime, setLastSaveTime] = useState<string | null>(null);
  
  // Refs for tracking internal state
  const initialized = useRef<boolean>(false);
  const didSaveRef = useRef<boolean>(false);
  const storageAvailable = useRef<boolean>(true);
  const initializationAttempts = useRef<number>(0);
  const databaseInitialized = useRef<boolean>(false);
  
  return {
    // State
    permissions,
    setPermissions,
    initialPermissions,
    setInitialPermissions,
    isLoading,
    setIsLoading,
    isDirty,
    setIsDirty,
    loadAttempts,
    setLoadAttempts,
    lastSaveTime,
    setLastSaveTime,
    
    // Refs
    initialized,
    didSaveRef,
    storageAvailable,
    initializationAttempts,
    databaseInitialized
  };
};
